__turbopack_context__.v({
  "heroImg": "gcgh7a_heroImg",
});
